import { useTranslation } from "react-i18next";
import { useWizard } from "../../../components/Wizard/Wizard";
import WelcomeStep from "../WelcomeStep";

export default function WelcomeToxicologicalStep() {
  const { t } = useTranslation();
  const { goToNextStep } = useWizard();

  return (
    <WelcomeStep
      confirmation={t("pages.booking.toxicological.steps.welcome.form.confirm")}
      instructionKey="pages.booking.toxicological.steps.welcome.instructions"
      onSubmit={goToNextStep}
      title={t("pages.booking.toxicological.steps.welcome.title")}
    />
  );
}
